import { UserTiers } from '../../../constants/userTiers';

export const canUserAccessSeveralOrganization = tier => {
  return tier === UserTiers.ADMIN || tier === UserTiers.FDA || tier === UserTiers.NoTier;
};

export const canUserAccessOrgName = tier => {
  return tier === UserTiers.ADMIN;
};

export const canUserAccessOrgUnitName = tier => {
  return tier === UserTiers.ADMIN || tier === UserTiers.FDA || tier === UserTiers.Org;
};
